import Types from '../Types';

// Customer

// Admin
const attemptFindAllRewards = (payload = {}) => ({
  type: Types.FIND_ALL_REWARDS_ATTEMPT, payload
});
const attemptFindOneReward = (payload = {}) => ({
  type: Types.FIND_ONE_REWARD_ATTEMPT, payload
});
const attemptAddReward = (payload = {}) => ({
  type: Types.ADD_REWARD_ATTEMPT, payload
});
const attemptSaveReward = (payload = {}) => ({
  type: Types.SAVE_REWARD_ATTEMPT, payload
});

export default {
  // Admin
  attemptFindAllRewards,
  attemptFindOneReward,
  attemptAddReward,
  attemptSaveReward
};



/** WEBPACK FOOTER **
 ** ./src/redux/reward/rewardActions.js
 **/